import { cn } from '@/lib/utils';

/**
 * Standard page header — title, description, actions (responsive stack on mobile).
 */
export default function PageHeader({ title, description, actions, className }) {
  return (
    <div
      className={cn(
        'mb-6 flex flex-col gap-4 border-b border-border pb-6 sm:mb-8 sm:flex-row sm:items-start sm:justify-between',
        className
      )}
    >
      <div className="min-w-0 flex-1 space-y-1">
        <h1 className="text-lg font-bold tracking-tight text-foreground sm:text-xl">{title}</h1>
        {description && <p className="max-w-2xl text-xs text-muted-foreground sm:text-sm">{description}</p>}
      </div>
      {actions && <div className="flex shrink-0 flex-wrap items-center gap-2">{actions}</div>}
    </div>
  );
}
